import React from 'react'
import { View } from 'react-native'
import BuilderBottomModal from '../../../../ui/molecules/BuilderBottomModal'
import { InputField } from '../../../../ui/atoms/builder-2.0/InputField'
import { Spacer } from '../../../../ui/atoms'
import { PaymentPlanCard } from '../../../../ui/atoms/PaymentPlanCard'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

import { Agreement } from '../../../Contractor/InvoicesTab/PayInvoice/Agreement'
import { DetailsRowItem } from '../../../Contractor/InvoicesTab/PayInvoice/DetailsRowItem'
import { BButton } from '../../../../ui/atoms/builder-2.0/Button'
import Loading from '../../../Loading'

interface PayWithBluetapeCreditFlow_PLAN_SELECTEDProps {
  onBack: () => void
  onClose: () => void
  onPay: () => void
  onAgreementPress: () => void
  loading: boolean
  days: number
  fee: number
  frequency: string
  term: number
  disabled: boolean
  totalAmount: number
  companyName: string
  paymentMethodName: string
  agreementDownloading: boolean
}

export const PayWithBluetapeCreditFlow_PLAN_SELECTED: React.FC<PayWithBluetapeCreditFlow_PLAN_SELECTEDProps> =
  ({
    loading,
    days,
    term,
    fee,
    frequency,
    totalAmount,
    companyName,
    paymentMethodName,
    agreementDownloading,
    onBack,
    onClose,
    onPay,
    onAgreementPress,
  }) => {
    const { t } = useTranslation(['errors', 'global'])

    const loanFee = Math.round(totalAmount * fee) / 100

    return (
      <BuilderBottomModal
        visible={true}
        title={t('global:payInvoice.pay-invoice')}
        onBack={onBack}
        onClose={onClose}
        paddingHorizontal={20}
        height={'100%'}
        testID={'pay-with-btc-invoice-modal'}
        footer={
          <Footer
            onSelect={onPay}
            disabled={loading}
            loading={loading}
            onAgreementPress={onAgreementPress}
            agreementDownloading={agreementDownloading}
          />
        }
      >
        {loading ? (
          <View style={{ height: 500 }} testID={'pay-with-btc-invoice-loading'}>
            <Loading />
          </View>
        ) : (
          <>
            <PaymentPlanCard
              onPress={() => {}}
              paymentOption={{
                days,
                term,
                fee,
                frequency,
              }}
              paymentAmount={totalAmount}
              selected
              forSummaryPage
            />
            <View
              style={{ paddingHorizontal: 20 }}
              testID={'pay--with-btc-invoice-info'}
            >
              <Spacer height={30} />
              <DetailsRowItem
                leftText={t('global:payInvoice.To')}
                rightText={companyName}
              />
              <DetailsRowItem
                leftText={t('global:payInvoice.invoice-amount')}
                rightText={totalAmount}
                money
              />
              <DetailsRowItem
                leftText={t('global:payInvoice.loan-fee')}
                rightText={loanFee}
                money
              />
              <DetailsRowItem
                leftText={t('global:payInvoice.total-amount')}
                rightText={`$ ${totalAmount + loanFee}`}
                money
              />
              <InputField
                label={t('global:payInvoice.select-autodebit-account')}
                editable={false}
                model={{
                  bankName: paymentMethodName.split('/')[0],
                }}
                name="bankName"
                style={{ height: 56, marginBottom: 20 }}
              />
              <Spacer height={30} />
            </View>
          </>
        )}
      </BuilderBottomModal>
    )
  }

const Footer = ({
  onSelect,
  disabled,
  loading,
  onAgreementPress,
  agreementDownloading,
}) => {
  const { t } = useTranslation('global')

  return (
    <>
      <Spacer height={15} />
      <Agreement
        onPress={onAgreementPress}
        downloading={agreementDownloading}
      />
      <View
        style={{
          backgroundColor: '#FFF',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Spacer height={12} />
        <View style={{ width: 335 }}>
          <BButton
            onPress={onSelect}
            buttonStyle={{ width: '100%', alignSelf: 'center' }}
            loading={loading}
            disabled={disabled}
          >
            {t('CreditApplication.Continue')}
          </BButton>
        </View>
        <Spacer height={45} />
      </View>
    </>
  )
}
